interface LogoProps {
  url: string;
  companyName: string;
}

export const Logo = (props: LogoProps) => {
  return <img alt={props.companyName} src={props.url} width="150" />;
};
